<div class="container-fluid" >
    <div class="row">
        <div class="col-sm-8 col-8">
            <h4 class="page-title">Forgot Password</h4>
        </div>
        <div class="col-sm-4 col-4">
            <mat-icon style="cursor: pointer;float: right; " (click)="closeDialog()">close</mat-icon>
        </div>
    </div>
    <div class="container-fluid" >

        <div class="row">

            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group" [class.has-error]="sellerEmail.invalid && sellerEmail.touched">
                    <label for="tagname" class="control-label">Email *</label>
                    <input type="email" autocomplete="off" [(ngModel)]="seller_email" #sellerEmail="ngModel" required class="form-control " pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" name="seller_email" placeholder="Enter Email">
                    <span class="help-block" *ngIf="sellerEmail.errors?.required && sellerEmail.touched">Email is required !</span>
                    <span class="help-block" *ngIf="sellerEmail.errors?.pattern && sellerEmail.touched">Enter a valid Email!</span>

                </div>
            </div>
            <div class="col-12">
                <button type="button" class="btn btn-primary" [disabled]="!seller_email" (click)="SendMail()" style="float: right">Save</button>
            </div>
        </div>

    </div>
</div>



